/* RESPONSIBLE TEAM: team-automation-foundations */
import type AppService from 'embercom/services/app-service';
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import type WorkflowConnector from 'embercom/models/operator/visual-builder/step/attribute-collector';
import type InsertableActionField from 'embercom/models/workflow-connector/insertable-action-field';

export default class WorkflowStepInputParameterMapping extends BaseValidator {
  @service declare intl: $TSFixMe;
  @service declare appService: AppService;

  validate(_stepType: any, _options: ValidationOptions, model: WorkflowConnector | any) {
    let insertableAction = model.action;

    if (!insertableAction) {
      return true; // Skip this validator until action is specified
    }

    if (!insertableAction.hasRequestParameters) {
      return true; // Skip this validator until action has request parameters
    }

    // A descriptor with a non-null source self-provides its runtime value
    // ('attribute' = baked-in workspace attribute, 'custom' = baked-in
    // literal/expression) and does not need a workflow-step mapping.
    // 'fin' descriptors nominally collect from conversation context, but a
    // workflow step must supply values explicitly, so they still need mapping.
    let fieldsRequiringMapping = insertableAction.requestParameters.filter(
      (field: InsertableActionField) => !field.source || field.source === 'fin',
    );

    if (fieldsRequiringMapping.length > model.actionInputParameterMappings.length) {
      return this.intl.t(
        'operator.workflows.visual-builder.validations.workflow-connector.missing-input-mapping',
      );
    } else {
      return true;
    }
  }

  static getDependentsFor() {
    return [
      'model.action',
      'model.actionInputParameterMappings',
      'model.actionInputParameterMappings.length',
    ];
  }
}
